module.exports = __webpack_public_path__ + "img/notice.c449b915.png";